// Color de fondo suave según el color de la caravana.
// Fuente única usada por el Rodeo y por Asistencia para que coincidan.
export function colorBg(color) {
  if (!color) return '#eee';
  const map = {
    amarillo: '#ffe600', rojo: '#ff4d4d', azul: '#d5e8ff', verde: '#d5ffd5',
    naranja: '#ffe4cc', rosa: '#ffd5ee', blanco: '#f5f5f5', negro: '#d0d0d0',
    celeste: '#d5f0ff', violeta: '#e8d5ff', gris: '#e0e0e0',
  };
  return map[color.toLowerCase()] || '#e8e8e8';
}
